import {NgModule} from '@angular/core';
import {RouterModule, Routes, TitleStrategy} from '@angular/router';
import {PrimaryAboutComponent} from './primary-about/primary-about.component';
import {PrimaryHelpComponent} from './primary-help/primary-help.component';
import {PrimaryAcknowledgementsComponent} from './primary-acknowledgements/primary-acknowledgements.component';
import {UnauthorizedComponent} from './errors/unauthorized.component';
import {NotFoundComponent} from './errors/not-found.component';
import {LoginComponent} from './login/login.component';
import {AfterLoginBlankComponent} from './after-login-blank/after-login-blank.component';
import {LogoutComponent} from './logout/logout.component';
import {SloLogoutComponent} from './slologout/slologout.component';
import {ContactUsComponent} from './contact-us/contact-us.component';
import {ForbiddenComponent} from './forbidden/forbidden.component';
import {PermissionsRequiredComponent} from './permissions-required/permissions-required.component';
import {MyProfileComponent} from './my-profile/my-profile.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {MyProfileGuard} from './shared/my-profile.guard';
import {ServiceLogListComponent} from './service-log/service-log-list/service-log-list.component';
import {ServiceLogDetailComponent} from './service-log/service-log-detail/service-log-detail.component';
import { CustomerSelectionComponent } from './customer-support/customer-selection/customer-selection.component';
import { GroupGuard } from './shared/group.guard';
import { SecurityService } from './shared/security.service';
import { TemplatePageTitleStrategy } from './shared/TemplatePageTitleStrategy';
import { GenericErrorComponent } from './errors/generic-error/generic-error.component';
import { oktaIdmCanActivate } from './shared/oktaIdmCanActivate';
import { PlatformIdmCreateSessionComponent } from '@platform-idm/sdk-angular';
import { TestComponent } from './test/test.component';

export function onAuthRequired({ oktaAuth, router }) {
  // Redirect the user to custom login page
  router.navigate(['/login']);
}

const routes: Routes = [
  //{
  //  path: 'create-session',
  //  component: CreateSessionComponent
  //},
  {
    path: 'create-session',
    component: PlatformIdmCreateSessionComponent
  },
  {
    path: 'test',
    component: TestComponent
  },

  {
    path: 'about',
    component: PrimaryAboutComponent,
    canActivate: [oktaIdmCanActivate],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'tokenManagement',
    loadChildren: () => import('./token-management/token-management.module').then(m => m.TokenManagementModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'configuration',
    loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule)
  },
  {
    path: 'help',
    component: PrimaryHelpComponent
  },
  {
    path: 'acknowledgements',
    component: PrimaryAcknowledgementsComponent,
    canActivate: [oktaIdmCanActivate],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'permissionsRequired',
    component: PermissionsRequiredComponent,
    canActivate: [oktaIdmCanActivate],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      skipServices: true
    },
  },
  {
    path: 'slologout',
    component: SloLogoutComponent,
    data: {
      skipServices: true
    },
  },
  {
    path: 'blank',
    component: AfterLoginBlankComponent
  },
  {
    path: 'contact-us',
    component: ContactUsComponent
  }, {
    path: 'forbidden',
    component: ForbiddenComponent
  },
  {
    path: 'my-profile',
    component: MyProfileComponent,
    canActivate: [oktaIdmCanActivate, MyProfileGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'service-log-list',
    component: ServiceLogListComponent,
    canActivate: [oktaIdmCanActivate, MyProfileGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'service-log-detail',
    component: ServiceLogDetailComponent,
    canActivate: [oktaIdmCanActivate, MyProfileGuard],
    data: {
      onAuthRequired
    }
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: {
      skipServices:true
    }
  },
  {
    path: 'customer-selection',
    component: CustomerSelectionComponent,
    canActivate: [oktaIdmCanActivate, GroupGuard],
    data: {
      onAuthRequired,
      groupGuardValidate: (svc: SecurityService) => {          
        return svc.isCanViewAnyCustomer();
      }
    }
  },
  {
    path: 'error',
    component: GenericErrorComponent
  },
  {
    path: 'shared-login',
    loadChildren: () => import('./shared-login/shared-login.module').then(m => m.SharedLoginModule)
  },
  {
    path: '',
    redirectTo: 'blank', pathMatch: 'full'
  },
  {
    path: '**',
    component: NotFoundComponent
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, enableTracing: false})],
  exports: [RouterModule]

  //Lets use this when we want to customize the html page title for each route
  //,providers: [
  //  {
  //    provide: TitleStrategy,
  //    useClass: TemplatePageTitleStrategy
  //  }
  //]
})
export class AppRoutingModule { }
